import { Dayjs } from 'dayjs';

export class ParseContext {
  constructor(public date: Dayjs, public format: string) {}

  isValid(): boolean {
    return !!this.date && this.date.isValid();
  }
}
